import { Injectable } from '@angular/core';
import { LMUrlUtilService } from './utils';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { LMLoggerService } from './lm-logger.service';
import { AppConstants } from '@utils/app.constants';

@Injectable()
export class LMGlobalPersistenceService implements LMPersistenceServiceBase {

  private headers: HttpHeaders;
  private instanceId: string;

  constructor(
    private http: HttpClient,
    private urlUtilService: LMUrlUtilService,
    private lmLoggerService: LMLoggerService
  ) {
    this.instanceId = this.lmLoggerService.instanceId;
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json;charset=utf-8');
  }

  getItem(key: string): LMStorageModelBase {
    return { };
  }

  /**
   * Saves to global storage on the server
   * @param key
   * @param payload
   */
  saveItem(key: string, payload: LMStorageModelBase): void {
    this.makeRequest(key, 'save', payload).subscribe((response) => {
      this.lmLoggerService.log([this, this.instanceId, 'saveItem()', key]);

      if (response.serverLog) {
        this.lmLoggerService.serverLog(response.serverLog);
      }

      if (response.status === AppConstants.STATUS_COMPLETED) {
        // no-op

      } else {
        this.lmLoggerService.error([ this, 'saveItem()', response.exception ]);
      }
    });
  }

  deleteItem(key: string): void {
    // no-op; server processes delete
  }

  private makeRequest(key: string, type: string, payload: LMStorageModelBase): Observable<any> {
    let url = this.urlUtilService.getBaseUrl() + '/globalstorage/';
    url = this.urlUtilService.propagateSessionKeys(url, '?');

    const requestData = {
      requestType: type,
      data:        payload,
      key,
    };

    return <Observable<any>> this.http.post(url, JSON.stringify(requestData), { headers: this.headers, }).pipe(
      catchError(error => this._handleError(error)));
  }

  private _handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}
